import React from 'react';
import Hotitemcard from './Hotitemcard';
import '../../styles/HotAccessories.css';

const MobileAccessories = ({hotAccessoriesCover,hotAccessories}) => {
    console.log("MobileAccessories",hotAccessoriesCover['mobileAccessories']);
    console.log("MobileAccessories data",hotAccessories['mobileAccessories']);
    return (
        <>
        <div className="HotAccessories">
                <div>
                    <img src={hotAccessoriesCover['mobileAccessories']} alt={`${'index'} offer`}></img>
                </div>    

                <div>
                  {
                      hotAccessories['mobileAccessories'].map((item,index)=>{
                          return(
                              <Hotitemcard key={item.image} name={item.name} prize={item.price} image={item.image} index={index}></Hotitemcard>
                          )
                      })
                  }
                </div>

           </div>
        </>
    )
}


export default MobileAccessories
